import { Component, Event, EventEmitter, Host, Prop, State, Watch, h } from '@stencil/core';
import clsx from 'clsx';

@Component({
  tag: 'linear-gradient-popup',
  styleUrl: 'linear-gradient-popup.scss',
  shadow: true
})
export class LinearGradientPopup {
  @Prop() size: 'xl' | '2xl' | '3xl' = '3xl';
  @Prop() assetPath: string;
  @Prop() escapeClose: boolean = false;

  sizes = {
    'xl': 'md:max-w-xl',
    '2xl': 'md:max-w-2xl',
    '3xl': 'md:max-w-3xl'
  };
  roundedClasses = {
    'rounded-full': 'rounded-full',
    'rounded-lg': 'rounded-lg',
    'rounded-md': 'rounded-md',
    'rounded-xl': 'rounded-xl',
    'rounded-sm': 'rounded-sm',
    'rounded-none': 'rounded-none'
  };
  @Prop() rounded: string = 'rounded-sm';
  @Prop() borderClass: string = 'gradient-popup-border-gradient';
  @Prop() open: boolean = false;
  @State() animateLeave: boolean = false;
  @State() shouldRender: boolean = false;
  @Event({ bubbles: false }) popupClose: EventEmitter<void>;

  private closeTimeout: ReturnType<typeof setTimeout>;

  @Watch('open')
  handleOpenChange(newVal: boolean) {
    if (newVal) {
      clearTimeout(this.closeTimeout);
      this.shouldRender = true;
      this.animateLeave = false;
      document.documentElement.style.overflow = 'hidden';
    } else {
      this.animateLeave = true;
      document.documentElement.style.overflow = '';
      this.closeTimeout = setTimeout(() => {
        this.shouldRender = false;
      }, 200);
    }
  }

  handleOverlayClick = (e: MouseEvent) => {
    if (e.target === e.currentTarget) {
      this.popupClose.emit();
    }
  };

  connectedCallback() {
    if (this.open) {
      this.shouldRender = true;
    }
  }

  render() {
    if (!this.shouldRender) return null;

    const sizeClasses = clsx(
      this.sizes[this.size],
      this.borderClass,
      'relative transform overflow-hidden rounded-0 rounded-t-[20px] md:rounded-xl shadow-xl transition-all md:my-8 w-full',
      this.animateLeave ? 'popup-leave' : 'popup-enter'
    );

    return (
      <Host>
        <div class="relative" aria-labelledby="modal-title" role="dialog" aria-modal="true">
          <div class="fixed inset-0 bg-[#000000E5] blur-[2px] transition-opacity z-140" aria-hidden="true"></div>
          <div class="fixed inset-0 z-140 w-screen overflow-y-hidden">
            <div onClick={this.handleOverlayClick} class="flex min-h-full items-end justify-center md:p-4 text-center md:items-center md:p-0">
              <div class={sizeClasses}>
                <div class="absolute -top-20 z-150">
                  <img class="w-6 h-6" alt="" src={this.assetPath + 'icons/closeWhite.svg'} />
                </div>
                <div class="p-4 rounded-0 rounded-t-[20px] md:rounded-xl cards-drop-down-gradient md:p-10">
                  <slot></slot>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Host>
    );
  }
}
